import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./OrderDetails.css";
import Footer from "./Footer";
import Header from "./Header";

function OrderDetails() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const fetchOrderDetails = async () => {
    try {

      const res = await fetch(
        `https://aethearia.store/superadmin/api/order-details/${id}`
      );

      const data = await res.json();

      if(data.status){
        setOrder(data.order);
        setProducts(data.products);
      }

    } catch(error){
      console.log(error);
    }
  };


  if(!order){
    return (
      <div className="order-loading">
        Loading order details...
      </div>
    )
  }


return(
    <>
    <Header/>
<div className="order-details-page">

<button 
className="back-btn"
onClick={()=>navigate(-1)}
>
← Back
</button>


<div className="order-header-card">

<div>
<h2>Order Details</h2>
<p>
Order ID : <b>{order.order_no}</b>
</p>
<p>
Placed on : {order.created_at}
</p>
</div>


<div className="status-box">

<span className="payment">
Payment : {order.payment_status}
</span>

<span className="order-status">
Status : {order.order_status}
</span>

</div>

</div>



<div className="customer-card">

<h3>Delivery Information</h3>

<div className="customer-grid">

<p>
<b>Name:</b> {order.fname} {order.lname}
</p>

<p>
<b>Email:</b> {order.email}
</p>


<p>
<b>Phone:</b> {order.phone}
</p>


<p>
<b>Address:</b> 
{order.address}, {order.apartment}
</p>


</div>

</div>





<div className="products-card">

<h3>Products</h3>


{
products.map((item)=>(
<div 
className="product-row"
key={item.id}
>


<img
src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
alt={item.product_name}
/>


<div className="product-info">

<h4>{item.product_name}</h4>

<p>
SKU : {item.variant_sku}
</p>

<p>
Quantity : {item.quantity}
</p>


</div>


<div className="price">

₹{item.price}

</div>


</div>
))
}


<div className="total-box">

<h3>
Total : ₹{order.subtotal}
</h3>

</div>


</div>


</div>
<Footer/>
</>
)

}


export default OrderDetails;